import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { useScrollReveal } from "../hooks/useScrollReveal";
import usePageSeo from "../hooks/usePageSeo";
import ProcessTimeline from "../components/ProcessTimeline";
import "./Home.css";

const HERO_BG = "/images/hero/hero.png";
const ARTISAN_IMG = "/images/hero/handcraft.png";
const HOME_SERVICE_IMAGES = [
  "/images/hero/Servizi - Porte Interne.jpg",
  "/images/hero/Servizi - Montaggio Arredi.jpg",
  "/images/hero/Servizi - Piccola Falegnameria.jpg",
];

export default function Home() {
  useScrollReveal();
  const { t, lang } = useLang();

  usePageSeo({
    lang,
    path: "/",
    title: lang === "IT"
      ? "GDM Installations | Falegnameria edile, porte interne e rifiniture in legno a Bari"
      : "GDM Installations | Building carpentry, interior doors and wood finishes in Bari",
    description: lang === "IT"
      ? "GDM Installations: porte interne, telai, controtelai, battiscopa, boiserie, pannellature, scale, ringhiere e falegnameria edile su misura a Bari e dintorni."
      : "GDM Installations: interior doors, frames, skirting boards, boiserie, wall cladding, staircases, railings and bespoke building carpentry in Bari and surroundings.",
    keywords: lang === "IT"
      ? "falegnameria edile Bari, porte interne Bari, boiserie Bari, battiscopa su misura Bari, scale in legno Bari, rivestimenti legno Bari, GDM Installations"
      : "building carpentry Bari, interior doors Bari, boiserie Bari, custom skirting boards Bari, wooden staircases Bari, wood cladding Bari, GDM Installations",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "GDM Installations",
      url: "https://gdminstallations.it/",
      image: "https://gdminstallations.it/images/hero/hero.png",
      description: lang === "IT"
        ? "Falegnameria edile artigianale a Bari: porte interne, rifiniture in legno, boiserie, scale e strutture in legno."
        : "Artisan building carpentry in Bari: interior doors, wood finishes, boiserie, staircases and timber structures.",
      areaServed: "Bari e dintorni",
      knowsAbout: [
        "Porte interne e telai",
        "Battiscopa e coprifili",
        "Boiserie e pannellature",
        "Scale in legno e ringhiere",
        "Falegnameria edile",
      ],
    },
  });

  return (
    <div className="home">
      <section className="hero" style={{ backgroundImage: `url(${HERO_BG})` }}>
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="hero-line1">{t.hero.line1}</span>
            <span className="hero-line2">{t.hero.line2}</span>
          </h1>
          <p className="hero-subtitle">{t.hero.subtitle}</p>
          <div className="hero-ctas">
            <Link to="/contact" className="btn-outline">{t.hero.bookCta}</Link>
          </div>
        </div>
      </section>

      <section className="elegance-section section">
        <div className="section-inner elegance-inner">
          <div className="elegance-text reveal-left">
            <h2 className="elegance-title">{t.elegance.title}</h2>
            <div className="gold-line-left" />
            <p className="elegance-body">{t.elegance.text}</p>
          </div>
          <div className="elegance-img reveal-right fade-in-delay-2">
            <img src={ARTISAN_IMG} alt="Artisan at work" />
          </div>
        </div>
      </section>

      <div className="gold-divider" />

      <section className="featured-section section">
        <div className="section-inner">
          <h2 className="section-title reveal-up">{t.featured.title}</h2>
          <p className="section-subtitle reveal-up fade-in-delay-1">{t.featured.subtitle}</p>
          <div className="gold-line" />
          <div className="home-services-grid reveal-scale fade-in-delay-2">
            {t.services.items.map((item, i) => (
              <div key={item.title} className="home-service-card">
                <img src={HOME_SERVICE_IMAGES[i]} alt={item.title} className="home-service-image" />
                <div className="home-service-body">
                  <span className="home-service-kicker">{t.services.title}</span>
                  <h3 className="home-service-title">{item.title}</h3>
                  <p className="home-service-description">{item.description}</p>
                  {item.details?.length ? (
                    <ul className="home-service-details">
                      {item.details.slice(0, 3).map((detail) => (
                        <li key={detail}>{detail}</li>
                      ))}
                    </ul>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
          <div className="featured-cta fade-in">
            <Link to="/contact" className="btn-outline">
              {t.contact.requestConsultation} <span style={{marginLeft:'0.4rem'}}>›</span>
            </Link>
          </div>
        </div>
      </section>

      <div className="gold-divider" />

      <ProcessTimeline />
    </div>
  );
}
